export const CommonActionTypes = {
  SET_LOADING: "SET_LOADING",
  SET_ACTIVE_TAB: "SET_ACTIVE_TAB",
  SET_SUCCESS: "SET_SUCCESS",
  SET_ERROR: "SET_ERROR",
  SET_BRANCHES: "SET_BRANCHES",
  SET_HUBS: "SET_HUBS",
  SET_VARIETIES: "SET_VARIETIES",
  SET_CROPS: "SET_CROPS",
  SET_SELECTED_CROP: "SET_SELECTED_CROP",
  SET_SELECTED_BRANCH: "SET_SELECTED_BRANCH",
  SET_SELECTED_DELIVERY: "SET_SELECTED_DELIVERY",
  SET_SELECTED_PO: "SET_SELECTED_PO",
  SET_SELECTED_PAYMENT: "SET_SELECTED_PAYMENT",
  SET_SELECTED_SAUDHA: "SET_SELECTED_SAUDHA",
  SET_INITIAL_DATA_LOADED: "SET_INITIAL_DATA_LOADED",
  SET_TC: "SET_TC",
  SET_PRIVACY: "SET_PRIVACY",
  SET_SUPPLIER_BIDS: "SET_SUPPLIER_BIDS",
  RESET_REDUCER: "RESET_REDUCER",
  SET_BAG_TYPE_LIST: "SET_BAG_TYPE_LIST",
  SET_AUCTION_BID: "SET_AUCTION_BID",
  SET_CROPS_UNIT: "SET_CROPS_UNIT",
  SET_PARAMETERS: "SET_PARAMETERS",
  SET_AUCTION_TYPE: "SET_AUCTION_TYPE",
  SET_SEASON: "SET_SEASON",
  SET_PO_NUMBER: "SET_PO_NUMBER",
  SET_VENDOR: "SET_VENDOR",
};
